// MusicContext.js
import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { BASE_URL_IMG, BASE_URL_MUSIC, getData } from '~/helper/apiService';

const MusicContext = createContext();

const MusicProvider = ({ children }) => {
  const [musicList, setMusicList] = useState([]);
  const [currentSong, setCurrentSong] = useState(null);
  const audioRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const data = await getData('/music/read');
      if (data && data.status === 'success') {
        setMusicList(data.data);
      }
    };
    loadData();
  }, []);

  const handlePlayMusic = (song) => {
    const songUrl = BASE_URL_MUSIC + song;
    if (currentSong === songUrl) {
      // Nếu bài hát đang phát, dừng nhạc và đặt lại state
      if (audioRef.current) {
        audioRef.current.audioEl.current.pause();
      }
      setCurrentSong(null);
    } else {
      setCurrentSong(songUrl);
    }
  };

  const playNextSong = () => {
    if (!currentSong || musicList.length === 0) return;
    const currentIndex = musicList.findIndex((song) => BASE_URL_IMG + song === currentSong);
    const nextIndex = (currentIndex + 1) % musicList.length; // vòng lặp lại bài đầu nếu hết danh sách
    setCurrentSong(BASE_URL_IMG + musicList[nextIndex]);
  };

  return (
    <MusicContext.Provider value={{ playNextSong,audioRef, currentSong, musicList, handlePlayMusic }}>
      {children}
    </MusicContext.Provider>
  );
};

export { MusicContext, MusicProvider };
